import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TableHead } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@totalsoft/rocket-ui";
import { StyledHeaderCell, StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsServicesTableHead = ({ canWrite, onAdd, isSaved }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <StyledTableRow>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Services.ReadOnly")}</StyledHeaderCell>
        <StyledHeaderCell sx={{ w: 1 / 2 }}>{t("FinancialProduct.Details.Rules.Details.Services.ServiceType")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.CalculationType")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.Supplier")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.PercentOrValue")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.PaymentFrequency")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.Financed")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.Default")}</StyledHeaderCell>
        <StyledHeaderCell >{t("FinancialProduct.Details.Rules.Details.Services.Mandatory")}</StyledHeaderCell>
        <StyledHeaderCell align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isSaved || !canWrite} onClick={onAdd}>
            {t("Add")}
          </Button>
        </StyledHeaderCell>
      </StyledTableRow>
    </TableHead>
  );
};

FinancialProductRulesEditDetailsServicesTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default FinancialProductRulesEditDetailsServicesTableHead;
